
"use strict"; // jshint ignore:line

import Player from './classes/Player.js';

export class unsafeFilter {

	static $inject = [ '$sce' ]; // jshint ignore:line

	constructor( $sce ) {
		return $sce.trustAsHtml;
	}
}

export function objLengthFilter() {
	return function(arg) {
		if (arg == null || typeof arg != "object") return NaN;
		return Object.keys( arg ).length;
	}
}

export class dateToStringFilter {

	static $inject = [ "$rootScope" ]; // jshint ignore:line

	constructor( $rootScope ) {
		var today = new Date();
		var isToday = (function( today ){
			return function( date ){ return _td( date ) == today };
		})( _td( today ));

		function _td( date ){ return date.getDate() + date.getMonth() + date.getFullYear(); }
		today.yyyy = today.getFullYear();

		return window.dateToString = $rootScope.dateToString = function dateToString( date ){
			if( !date ) return;
			if( date instanceof Date ){
				if( isToday( date )){
					return "klo. "+ date.getHours() +":"+ date.getMinutes();
				} else {
					var yyyy = date.getFullYear();
					if( yyyy == today.yyyy ){
						var dd = date.getDate();
						var mm = date.getMonth()+1;
						return (dd<10?"0":"") + dd + "." + (mm<10?"0":"") + mm + ".";
					} else {
						return date.toLocaleDateString();
					}
				}
			} else if( typeof date == "string" ){
				try {
					date = new Date(date);
				} catch( err ){
					console.error(err);
					return date;
				}
				return dateToString( date );
			} else if( date ){
				return date.toString();
			}
		};
	}
}

export class contenteditableDirective {

	static $inject = [ '$sce' ]; // jshint ignore:line

	constructor( $sce ) {
		return {
			restrict: 'A',
			require: '?ngModel',
			link: function(scope, element, attrs, ngModel) {
				if (!ngModel) return;

				ngModel.$render = function() {
					element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
				};

				element.on('blur keyup change', function() {
					scope.$evalAsync(read);
				});

				read();

				function read() {
					var html = element.html();
					if ( attrs.stripBr && html == '<br>' ) {
						html = '';
					}
					ngModel.$setViewValue(html);
				}
			}
		};
	}
}

export function customOnChangeDirective() {
	return {
		restrict: 'A',
		link: function( scope, element, attrs ){
			var onChangeHandler = scope.$eval( attrs.customOnChange );
			element.on('change', onChangeHandler);
			element.on('$destroy', function( ){
				element.off();
			});
		}
	};
}

export function convertToNumberDirective() {
	return {
		require: 'ngModel',
		link: function(scope, element, attrs, ngModel) {
			ngModel.$parsers.push(function(val) {
				return val != null ? parseInt(val, 10) : null;
			});
			ngModel.$formatters.push(function(val) {
				return val != null ? '' + val : null;
			});
		}
	};
}

export function numberToScaleDirective() {
	return {
		require: 'ngModel',
		link: function(scope, element, attrs, ngModel) {
			var scale = parseFloat(attrs.numberToScale) || 1;

			if (!isNaN( scale ) && scale != 1) {
				ngModel.$parsers.push(function(val) {
					return val * scale;
				});
				ngModel.$formatters.push(function(val) {
					return val / scale;
				});
			}
		}
	};
}

export function numberToFixedDirective() {
	return {
		require: 'ngModel',
		link: function(scope, element, attrs, ngModel) {

			var scale = parseFloat(attrs.numberToFixed) || 0;

			if( !isNaN( scale )){
				ngModel.$options.$$options.allowInvalid = true;
				scale = Math.pow( 10, scale );
				ngModel.$parsers.push( fixer );
				ngModel.$formatters.push( fixer );
			}

			function fixer( val ) {
				return Math.round(val * scale) / scale;
			}
		}
	};
}

export function artestInputUidDirective() {
	var uids = {
		IMAGES : "B2"
	};
	return {
		require: 'ngModel',
		link: function(scope, element, attrs, ngModel) {
			var type = attrs.artestInputUid || null, regexp = "[A-F0-9]{16}";

			try {
				if (type) {
					if (type=uids[ type.toUpperCase() ]) {
						var oct = type.oct || type;
						if (oct) {
							regexp = oct+"[A-F0-9]{14}";
							element.attr( "pattern", regexp );
							regexp = new RegExp( "^"+ regexp +"$" );
						}
					} else throw "Directive artestInputUid :: Invalid argument";
				}
			} catch( error ) {
				console.error( error );
			}

			element.attr( "pattern", regexp );
			regexp = new RegExp( "^"+ regexp +"$" );

			ngModel.$validators.pattern = function( a, b ) {
				return !b || b.length == 0 || (regexp && regexp.test( b ));
			};
			ngModel.$parsers.push(function( val ){
				return val.toUpperCase();
			});
		}
	};
}

export class modalLurkingFooterDirective {
	
	static $inject = [ "$document", "$window", "$timeout" ]; // jshint ignore:line

	constructor( $document, $window, $timeout ) {
		return {
			link: function(scope, element, attrs, ctrl) {
				var welem = element.parent().parent().parent();

				welem.on("scroll", handler );
				scope.$watch(heightwatcher, handler);

				scope.$on("$destroy", function(){
					welem.off("scroll", handler );
				});

				var rect;
				function heightwatcher(){
					return (rect = element.parent()[0].getBoundingClientRect()).height;
				}
				function handler( event ){
					var delta = window.innerHeight - rect.y - rect.height;

					if( rect.top+rect.height - window.innerHeight <= 0 ) delta = 0

					element.parent().css({ "padding-bottom": element[0].getBoundingClientRect().height+"px" });
					element.css({ "margin-top": Math.floor(delta)+"px" });
				}

				$timeout(handler);
			}
		}
	}
}